<template>
  <div id="IndexSIQA_div">

    <menusuperior titulo="SIQA" subtitulo="Sistema de quejas administrativas"></menusuperior>
    <menuizquierda></menuizquierda>

    <div class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>

  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SIQA/Comun/Plantilla.vue